// extracted by mini-css-extract-plugin
export var aboutUsContainer = "AboutUsSection-module--aboutUsContainer--GE3qD";
export var backgroundWord = "AboutUsSection-module--backgroundWord--QdF5S";
export var contentContainer = "AboutUsSection-module--contentContainer--qHUEP";
export var leftSideLight = "AboutUsSection-module--leftSideLight--+tICX";
export var mainText = "AboutUsSection-module--mainText--G7TWo";
export var textContainer = "AboutUsSection-module--textContainer--31PRE";